module.exports = __webpack_public_path__ + "img/OVCA_pDC.cfc28c0f.png";